import { PosIconProps, SvgWrapper } from './SvgWrapper';

export const RankPremiumIcon = (props: Omit<PosIconProps, 'viewBox'>) => {
  return (
    <SvgWrapper viewBox="0 0 8 8" {...props}>
      <path
        d="M1 5.12305C1.55212 5.12305 1.99974 5.57099 2 6.12305V7.12305C2 7.67533 1.55228 8.12305 1 8.12305C0.447715 8.12305 2.41411e-08 7.67533 0 7.12305V6.12305C0.000263738 5.57099 0.447878 5.12305 1 5.12305ZM3.875 2.40137C4.42728 2.40137 4.875 2.84908 4.875 3.40137V4.40137C4.875 4.95365 4.42728 5.40137 3.875 5.40137C3.32272 5.40137 2.875 4.95365 2.875 4.40137V3.40137C2.875 2.84908 3.32272 2.40137 3.875 2.40137ZM7 0C7.55228 2.41411e-08 8 0.447715 8 1V2C8 2.55228 7.55228 3 7 3C6.44772 3 6 2.55228 6 2V1C6 0.447715 6.44772 8.07189e-09 7 0Z"
        fill={props.fill ?? '#191C1F'}
      />
    </SvgWrapper>
  );
};
